import type { TagDto } from './tags.dto';

/** A tag on an event — set by a person or by the AI tagger, editable either way. */
export interface EventTag {
  id: string;
  name: string;
  color: string | null;
  isDefault: boolean;
}

export const mapTag = ({ id, name, color, is_default }: TagDto): EventTag => ({
  id,
  name,
  color,
  isDefault: is_default,
});
